import React from "react";
import PropTypes from "prop-types";
import ReportDownload from "./ReportDownload";
import Icon from './Icon';
import SelectControl from './Form/Controls/SelectControl';
import i18n from "../i18n/translate";

export default class PaginationHeader extends React.Component {
  static propTypes = {
    activePage: PropTypes.number,
    changePageSize: PropTypes.func.isRequired,
    clearFilters: PropTypes.func,
    closeTimeoutModal: PropTypes.func,
    dataSize: PropTypes.number,
    downloadAction: PropTypes.func,
    downloadParams: PropTypes.any,
    downloadProcessing: PropTypes.bool,
    downloadTimedOut: PropTypes.bool,
    downloadUrl: PropTypes.string,
    filterDisplayed: PropTypes.bool,
    filterInEffect: PropTypes.bool,
    hasPagination: PropTypes.bool,
    pSize: PropTypes.number,
    resultsDisplayed: PropTypes.bool,
    showDownloadLink: PropTypes.bool,
    showPageSizeDropdown: PropTypes.bool,
    totalCount: PropTypes.number,
    toggleFilter: PropTypes.func
  };

  constructor(props){
    super(props);
  }

  static defaultProps = {
    showPageSizeDropdown: true
  };

  onChange = (pageSize) => {
    this.props.changePageSize(pageSize.value);
  }

  render() {
    const { activePage, clearFilters, closeTimeoutModal, dataSize, downloadUrl, downloadProcessing, downloadTimedOut,
      filterDisplayed, downloadAction, downloadParams, filterInEffect, hasPagination,
      resultsDisplayed, pSize, showDownloadLink, toggleFilter, totalCount } = this.props;

    const itemPerPageOptions = [
      { value: 20, label: "20" },
      { value: 50, label: "50" },
      { value: 100, label: "100" },
      { value: 200, label: "200" }
    ];

    const previousItemCount = pSize * (activePage - 1);

    const headerResults = hasPagination ? (
      <div className="results">
        <span className="results-label">{i18n.t('Results: ')}</span>
        {i18n.t('%s of %s', {
          postProcess: 'sprintf',
          sprintf: [`${previousItemCount + 1} - ${previousItemCount + dataSize}`, totalCount]
        })}
      </div>
    ) : (
      <div className="results">
        <span className="results-label">{i18n.t('Results:')}</span> {totalCount}
      </div>
    );

    const itemsPerPage = (
      <div className="items-per-page">
        <span className="items-label">{i18n.t('Items Per Page:')}</span>
        <SelectControl
          {...this.props}
          options={itemPerPageOptions}
          valueKey="value"
          labelKey="label"
          clearable={false}
          dataValue={pSize}
          valueOverride={true}
          onChange={this.onChange}
          multi={false}
          searchable={false} />
      </div>
    );

    const showHeader = resultsDisplayed || toggleFilter || filterInEffect || showDownloadLink;

    if (showHeader) {
      return (
        <div className="pagination-header">
          {resultsDisplayed && headerResults}
          {toggleFilter &&
          <span className="filter-toggle">
            <a onClick={toggleFilter}>
              {filterDisplayed ? i18n.t('Hide Filters') : i18n.t('Show Filters')}
            </a>
          </span>
          }
          {filterInEffect &&
          <span className="filter-toggle">
            <a onClick={clearFilters}>
              <Icon iconType="replay" />{i18n.t('Reset Filters')}
            </a>
          </span>
          }
          <div className="right-items">
            {showDownloadLink &&
              <div className="download-link">
                <ReportDownload
                  downloadUrl={downloadUrl}
                  downloadProcessing={downloadProcessing}
                  downloadTimedOut={downloadTimedOut}
                  downloadAction={downloadAction}
                  downloadParams={downloadParams}
                  closeTimeoutModal={closeTimeoutModal}
                />
              </div>}
            {this.props.showPageSizeDropdown && itemsPerPage}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
